module.exports = __webpack_public_path__ + "img/IMG_8673_FoamcoreMatted.8020528b.jpg";